import { render, staticRenderFns } from "./AddInvestor.vue?vue&type=template&id=4488c8d3&"
import script from "./AddInvestor.vue?vue&type=script&lang=js&"
export * from "./AddInvestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports